interface IPageName {
    ORDERS: "Orders",
    ORDER_DETAILS: "OrderDetails",
    USERS: "Users",
    OVERVIEW: "Overview",
    CREATE_ORDER: "CreateOrder"
}

export const PAGE_NAME: IPageName = {
    ORDERS: "Orders",
    ORDER_DETAILS: "OrderDetails",
    USERS: "Users",
    OVERVIEW: "Overview",
    CREATE_ORDER: "CreateOrder"
}